import React, { useState } from 'react';
import api from '../services/api';
import Button from './Button';

const ShopSettings = ({ shop, onUpdate }) => {
  const [icon, setIcon] = useState(null);
  const [banner, setBanner] = useState(null);
  const [serverDescription, setServerDescription] = useState(shop.serverDescription || '');

  const handleIconChange = (e) => {
    setIcon(e.target.files[0]);
  };

  const handleBannerChange = (e) => {
    setBanner(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    if (icon) {
      formData.append('icon', icon);
    }
    if (banner) {
      formData.append('banner', banner);
    }
    formData.append('serverDescription', serverDescription);

    try {
      const res = await api.put(`/shops/${shop._id}/media`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      onUpdate(res.data);
      alert('Zaktualizowano media sklepu!');
    } catch (err) {
      console.error(err);
      alert('Wystąpił błąd podczas aktualizacji mediów.');
    }
  };

  return (
    <div className="bg-gray-800 p-6 rounded-lg">
      <h2 className="text-2xl font-bold mb-4 text-white">Ustawienia Sklepu</h2>
      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label htmlFor="icon" className="block text-white mb-2">Ikona sklepu</label>
          <input type="file" id="icon" onChange={handleIconChange} className="input" />
          {shop.icon && <img src={shop.icon} alt="Ikona sklepu" className="w-24 h-24 mt-2 rounded-full" />}
        </div>
        <div className="mb-4">
          <label htmlFor="banner" className="block text-white mb-2">Baner sklepu</label>
          <input type="file" id="banner" onChange={handleBannerChange} className="input" />
          {shop.banner && <img src={shop.banner} alt="Baner sklepu" className="w-full h-32 mt-2 object-cover rounded-lg" />}
        </div>
        <div className="mb-4">
          <label htmlFor="description" className="block text-white mb-2">Opis serwera</label>
          <textarea
            id="description"
            value={serverDescription}
            onChange={(e) => setServerDescription(e.target.value)}
            className="input"
            rows="4"
          ></textarea>
        </div>
        <Button type="submit">Zapisz zmiany</Button>
      </form>
    </div>
  );
};

export default ShopSettings;